import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import {apiV2} from "api/firebase";
import AditusIcon from "view/images/AditusIcon";
import useStyles from "./styles";

type SSOAditusProps = {
  showId: string;
  exhibitorPairId: string;
};

function SSOAditus({showId, exhibitorPairId}: SSOAditusProps) {
  const classes = useStyles({headerBackground: false});

  const handleButtonClick = async () => {
    const {link} = await apiV2.aditus.getSsoLink({
      showId,
      exhibitorPairId,
    });

    if (!link) {
      return;
    }
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div>
      <Box className={classes.tooltipAppItem}>
        <Box className={classes.tooltipItemLink} onClick={handleButtonClick}>
          <AditusIcon />
          <Typography>Aditus</Typography>
        </Box>
      </Box>
    </div>
  );
}

export default SSOAditus;
